import { CardActions } from '@mui/material'
import styled from 'styled-components'

export const FilterCardActionsStyled = styled(CardActions)`
  padding: ${({ theme }) => theme.spacing(2)};
  justify-content: end;
  align-items: end;
`
